import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Node } from 'src/app/sidebar-station/model/node.interface';

import { FlatNode } from './model/node.interface';

@Injectable()
export class SidebarStationService {
    private sidebarListSubject: BehaviorSubject<Node[]>;
    public selectionItem: EventEmitter<FlatNode> = new EventEmitter<FlatNode>();

    constructor() {
        this.sidebarListSubject = new BehaviorSubject<Node[]>([]);
    }

    setSidebarListInMemory(list: Node[]) {
        this.sidebarListSubject.next(list);
    }

    getObservableSidebarList(): Observable<Node[]> {
        return this.sidebarListSubject.asObservable();
    }

    applySelectionItem(item: any) {
        this.selectionItem.emit(item);
    }

}
